module.exports = __webpack_public_path__ + "img/yeYaBeng1.5b395d31.png";